import React from "react";

import svg from "../../assets/images/icons/show.svg";

export const ShowIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Show"}
    />
);
